import axios from "axios"
import { useEffect, useState } from "react"








export const changeidtopress = (id) => {
let hh
    switch(parseInt(id)){
    case 1: 
    case 3: 
     hh =  "GL540"
    break;
    case 2: 
case 4 :
      hh =  "GL440"
      break;
    case 5 :
    case 6 :
      hh =  "M110"
      break;
     case 7 :
      hh =  "Digital"
      break;
        case 8: 
      hh =  "Digital"
      break;
       case 9 :
      hh =  "Colormax" 
      break;
        default:
             hh =  <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Press</span></>
             break;
    }
    return hh
}


export const colorchange = (item) => {

let a
switch(item){
  
        case "On Proofing" :     
            a = '#FFB6C1'  
        break;


   case "On Prepress" :
      case "Off Proofing" :  
a = '#8AFF8A';
break;


  case "Off Prepress" :
a = '#FF687E';
break;

  case "Ready Bindery" :
a = '#EF8A45';
break;


  case "On Plating" :
 case "Ready Plating" :
    case "Plated" :
           case "Off Plating" :
  a = '#00FF00';
break;

    // case "Off Plating" :
    //     a = '#79BB43';
    //     break;



    case "On Digital" :
    case "On Colormax" :
                a = 'rgb(192, 64, 0,.9)'
        break;  
            case "On Press" :     
        a = '#f5f513ff'  
        break;   
    case "Off Press" :
        a = 'var(--off)'
        break;



    case "Incomplete Press" :
    case "Incomplete Prepress" :
    case "Incomplete Proofing" :
    case "Incomplete Plating" :
    case "Incomplete Digital" :
    case "Incomplete Colormax" :
            a = '#CA001E'
        break;
    case "AA Changes Press" :
    case "AA Changes Prepress" :
    case "AA Changes Proofing" :
    case "AA Changes Plating" :
    case "AA Changes Digital" :
    case "AA Changes Colormax" :
            a = 'var(--aa)'
         break;
        case "PE Changes Press" :
        case "PE Changes Prepress" :
        case "PE Changes Proofing" :
        case "PE Changes Plating" :
        case "PE Changes Digital" :
        case "PE Changes Colormax" :
                a = 'var(--pe)'
         break;
   
    case "Ready Digital":
    case "Ready Colormax":
         a = 'var(--ready)'
         break;
  
    
        case "Ready Press":
            a="#79BB43"
            break; 
            
            
            case "Prepress On Hold":
            case "Proofing On Hold":
            case "Plating On Hold":
                a = 'rgb(255,0,0,.7)'
                break;
///////////////////////////////////////////BINDERY/////////////////////////////////////////////

   case "On Bindery" :
  case "On Cutting" :
    case "On Folding" :
    case "On Die Cutting" :
    case "On Gluer" :
    case "On Handwork" :
    case "On Hand Stitching" :
    case "On Stitching" :
    case "On Drilling" :
    case "On Tabbing" :
    case "On Inkjetting" :
    case "On Inserting" :
    case "On Mail Handwork" :
    case "On Coil Binding" :
    case "On Shrink Wrap" :
    case "On Banding" :
    case "On Tabbing / Inkjetting" :
a= '#B8B8FF';
break;
 case "Off Bindery" :
 case "Off Cutting" :
    case "Off Folding" :
    case "Off Die Cutting" :
    case "Off Gluer" :
    case "Off Handwork" :
    case "Off Hand Stitching" :
    case "Off Stitching" :
    case "Off Drilling" :
    case "Off Tabbing" :
    case "Off Inkjetting" :
    case "Off Inserting" :
    case "Off Mail Handwork" :
    case "Off Coil Binding" :
    case "Off Shrink Wrap" :
    case "Off Banding" :
    case "Off Tabbing / Inkjetting" :
a = '#5C5CFF';
break;
 case "Incomplete Bindery" :
  case "Incomplete Cutting" :
    case "Incomplete Folding" :
    case "Incomplete Die Cutting" :
    case "Incomplete Gluer" :
    case "Incomplete Handwork" :
    case "Incomplete Hand Stitching" :
    case "Incomplete Stitching" :
    case "Incomplete Drilling" :
    case "Incomplete Tabbing" :
    case "Incomplete Inserting" :
    case "Incomplete Inkjetting" :
    case "Incomplete Mail Handwork" :
    case "Incomplete Coil Binding" :
    case "Incomplete Shrink Wrap" :
    case "Incomplete Banding" :
     case "Incomplete Tabbing / Inkjetting" :
a = 'orchid';
break;


        case "Holiday":
            a="#FF00FF"
            break; 
                default:
                    a = 'rgb(0,0,0,.2)'
                    break;
    }
   


    return a
}

export const getemployeebynamefromempid = (id,list) => {

let h = list?.filter(filt => parseInt(filt.empId) === parseInt(id))
  
    return h[0]?.firstName+' '+h[0]?.lastName.substr(0,1) || "Unkown"
}

export const getemployeefromempid = (id,list) => {

let h = list?.filter(filt => parseInt(filt.empId) === parseInt(id))
  
    return h[0]
}

export const getcustomerfromname = (name, list) => {
    console.log(name)
      console.log(list)
  return list?.find(customer => customer.name === name);
}

export const convertprintstyle = (style) => {
    let a = 0
    let b = 0
    switch(style){
        case "Work & Turn":
            a = 2
            b = .25
        break;
        case "Sheetwise":
            a = 2
            b = .50
        break;
        case "Work & Tumble":
            a = 1
            b = .25
        break;
        case "One-Sided":
            a = 1
            b = .25
        break;
        case "Perfect":
            a = 1
            b = .25
        break;
    }
    return {pass:a,mrtime:b}
}


export const convertSheetSize = (size) => {
let newsize = Math.floor(size)
return size > newsize  ?  size : newsize
}


